import { GreenCircleCheckmark } from '../../../../svg/GreenCircleCheckmark';

export const MatchDeclinedContent = () => {
  return (
    <div
      className={'flex flex-col gap-8 text-center items-center justify-center md:mt-8 md:w-[500px]'}
    >
      <GreenCircleCheckmark size={150} />
      <div className='text-lg flex flex-col gap-4'>
        <div className='font-semibold'>Thanks for your feedback!</div>
        <div className='blue-links'>
          Questions or concerns about finding a match?{' '}
          <a href='mailto:match@movingworlds'>Send us a message</a> and a real person from our team
          will follow up with you.
        </div>
      </div>
    </div>
  );
};
